import { SubscriptionLike } from 'rxjs';

export class RestComponent {
  /**
   * Toggle error message
   * @type {boolean}
   */
  error: boolean = false;

  /**
   * Error message
   * @type {string}
   */
  errorMessage: string;

  /**
   * Successful response message
   * @type {string}
   */
  resultMessage: string;

  /**
   * Form send and waiting for response
   * @type {boolean}
   */
  loadingState: boolean = false;

  /**
   * Subscribe for events
   *
   * Example:
   *   this.subscription = this.route.queryParams.subscribe(...);
   */
  subscription: SubscriptionLike;
}
